document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll("[data-collection]");
  const container = document.getElementById("collection-products");

  if (!buttons.length || !container) return;

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const handle = button.dataset.collection;

      if (!handle) return;

      // Active state
      
      buttons.forEach((btn) => btn.classList.remove("bg-[#8B6F47]", "text-white"));
      button.classList.add("bg-[#8B6F47]", "text-white");

      const url = `/collections/${handle}?view=ajax`;

      container.innerHTML = "<div class='h-[50vh] flex justify-center items-center'>Loading...</div>";

      fetch(url)
        .then((res) => res.text()) // ✅ FIXED
        .then((html) => {
          container.innerHTML = html; // ✅ direct inject
          initAll();
        })
        .catch((err) => {
          console.error("Error loading collection:", err);
        });
    });
  });
});